import {
  SanityAdaptativeSection,
  SanityAdvantageProductSection,
  SanityButtonSection,
  SanityCenterTextSection,
  SanityColumnsSection,
  SanityCommentsSection,
  SanityExampleSection,
  SanityExpertiseCardSection,
  SanityFormSection,
  SanityHubspotFormSection,
  SanityImageSection,
  SanityMapSection,
  SanityNewsletterSection,
  SanityPartnerSection,
  SanityProductCardSection,
  SanityTechnoCardSection,
  SanityTextButtonImgBgSection,
  SanityTextPortraitSection,
  SanityTitleSection,
  SanityValuesSection,
  SanityVideoTitleTextSection,
} from 'graphql-types';
import React from 'react';
import { SanityCountrySettings } from '../../../graphql-types';
import { isCountryAllowed } from '../../utils/isCountryAllowed';
import { usePageContext } from '../context/pageContext';
import { useGeoContext } from '../context/useGeoContext';
import { AdaptativeSection } from './AdaptativeSection';
import { AdvantageProductSection } from './AdvantageProductSection';
import { ButtonSection } from './ButtonSection';
import { CenterTextSection } from './CenterTextSection';
import { ColumnsSection } from './ColumnsSection';
import { CommentsSection } from './CommentsSection';
import { CommentsSectionDesktop } from './CommentsSectionDesktop';
import { ExampleSection } from './ExampleSection';
import { ExpertiseCardSection } from './ExpertiseCardSection';
import { FormSection } from './FormSection';
import { HubspotFormSection } from './HubspotFormSection';
import { ImageSection } from './ImageSection';
import { MapSection } from './MapSection';
import { NewsletterSection } from './NewsletterSection';
import { PartnerSection } from './PartnerSection';
import { PartnerSectionDesktop } from './PatnerSectionDesktop';
import { ProductCardSection } from './ProductCardSection';
import { TechnoCardSection } from './TechnoCardSection';
import { TextButtonImgBgSection } from './TextButtonImgBgSection';
import { TextPortraitSection } from './TextPortraitSection';
import { TitleSection } from './TitleSection';
import { ValuesSection } from './ValuesSection';
import { VideoTitleTextSection } from './VideoTitleTextSection';

export type SectionsType = (
  | SanityExpertiseCardSection
  | SanityImageSection
  | SanityVideoTitleTextSection
  | SanityTextButtonImgBgSection
  | SanityTextPortraitSection
  | SanityCenterTextSection
  | SanityProductCardSection
  | SanityNewsletterSection
  | SanityFormSection
  | SanityValuesSection
  | SanityTechnoCardSection
  | SanityAdvantageProductSection
  | SanityExampleSection
  | SanityMapSection
  | SanityCommentsSection
  | SanityButtonSection
  | SanityPartnerSection
  | SanityAdaptativeSection
  | SanityColumnsSection
  | SanityTitleSection
  | SanityHubspotFormSection
)[];

interface Props {
  sections: SectionsType;
}

export const Sections = ({ sections }: Props) => {
  const { country } = useGeoContext();
  const { lang, defaultLang } = usePageContext();

  return (
    <>
      {sections
        ?.filter((e) => e && isCountryAllowed(country, e?.countrySettings as SanityCountrySettings))
        .map((section, index) => {
          switch (section.__typename) {
            case 'SanityTitleSection': {
              return (
                <TitleSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }
            case 'SanityCenterTextSection': {
              return (
                <CenterTextSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityProductCardSection': {
              return (
                <ProductCardSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityNewsletterSection': {
              return (
                <NewsletterSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityFormSection': {
              return (
                <FormSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityValuesSection': {
              return (
                <ValuesSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityTechnoCardSection': {
              return (
                <TechnoCardSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityExpertiseCardSection': {
              return (
                <ExpertiseCardSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityImageSection': {
              return (
                <ImageSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityVideoTitleTextSection': {
              return (
                <VideoTitleTextSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityTextButtonImgBgSection': {
              return (
                <TextButtonImgBgSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityTextPortraitSection': {
              return (
                <TextPortraitSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityColumnsSection': {
              return (
                <ColumnsSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityAdaptativeSection': {
              return (
                <AdaptativeSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityPartnerSection': {
              return (
                <React.Fragment key={`section-${index}`}>
                  <PartnerSection section={section} />
                  <PartnerSectionDesktop section={section} />
                </React.Fragment>
              );
            }

            case 'SanityButtonSection': {
              return (
                <ButtonSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }
            case 'SanityCommentsSection': {
              return (
                <React.Fragment key={`section-${index}`}>
                  <CommentsSection section={section} />
                  <CommentsSectionDesktop section={section} />
                </React.Fragment>
              );
            }

            case 'SanityMapSection': {
              return (
                <MapSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityExampleSection': {
              return (
                <ExampleSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityAdvantageProductSection': {
              return (
                <AdvantageProductSection
                  key={`section-${index}`}
                  section={section}
                />
              );
            }

            case 'SanityHubspotFormSection': {
              return (
                <HubspotFormSection
                  key={`section-${index}`}
                  region={section.formSettings?.region || ""}
                  portalId={section.formSettings?.portalId || ""}
                  formId={section.formSettings?.formId?.[lang] || section.formSettings?.formId?.en || ""}
                />
              );
            }

            default:
              return null;
          }
        })}
    </>
  );
};
